import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import './DisclaimerModal.css';

const DisclaimerModal = () => {
  // Use sessionStorage so that the modal resets on a new session
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hasShownDisclaimer = sessionStorage.getItem('disclaimerShown');
    if (!hasShownDisclaimer) {
      setIsVisible(true);
    }
  }, []);

  const handleClose = () => {
    setIsVisible(false);
    sessionStorage.setItem('disclaimerShown', 'true');
  };

  if (!isVisible) return null;

  return (
    <motion.div
      className="disclaimer-overlay"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
    >
      <motion.div 
        className="disclaimer-modal"
        initial={{ scale: 0.8 }}
        animate={{ scale: 1 }}
        transition={{ duration: 0.5 }}
      >
        <p>
        Disclaimer: The Bar Council of India does not permit advertisement or solicitation for law related work by legal practitioners and professionals. This website does not solicit work and/ or advertise for law related services. By clicking on the “I agree” below, the viewer/user acknowledges that there has been no solicitation or advertisement or invitation or enticement or communication of whatsoever nature for any sort of legal or para legal work or services from us or any of our advocates. Accessing this web site does not create client- attorney relationship. The contents of this website are solely available at your request for informational purposes only. We urge you to seek advice from your professional counsellors before using any information in this website for your requirements. No information provided herein shall be construed to be legal advice or creating client attorney relationship.
        </p>
        <button onClick={handleClose} className="disclaimer-btn">I Understand</button>
      </motion.div>
    </motion.div>
  );
};

export default DisclaimerModal;
